import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      marginTop: 'auto',
      paddingTop: 30,
      paddingBottom: 40,
      fontSize: 13,
      lineHeight: 1.2,
      [theme.breakpoints.up('md')]: {
        fontSize: 20
      }
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      gap: 16,
      [theme.breakpoints.up('md')]: {
        textAlign: 'start'
      }
    },
    links: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'center'
      },
      '& > *': {
        color: theme.palette.common.white,
        position: 'relative',
        textDecoration: 'underline',
        marginBottom: 10,
        [theme.breakpoints.up('md')]: {
          color: 'inherit',
          marginBottom: 0,
          '&:not(:last-child)': {
            marginRight: 20,
            '&::after': {
              content: '""',
              position: 'absolute',
              top: 3,
              bottom: 3,
              width: 1,
              right: -15,
              backgroundColor: 'currentColor'
            }
          }
        }
      }
    },
    link: {
      color: theme.palette.common.white,
      textDecoration: 'underline'
    }
  }), { name: 'Footer' }
);
